/*
 * Inspired by http://redux.js.org/docs/recipes/ReducingBoilerplate.html#generating-reducers
 */
import isEmpty from 'lodash/isEmpty';

function createReducer(initialState, handlers = {}) {
  return (state = initialState, action) => {
    if (typeof handlers[action.type] === 'function') {
      const newState = handlers[action.type](state, action);
      if (!isEmpty(newState)) {
        return Object.assign({}, state, newState);
      }
    }
    return state;
  };
}

export default createReducer;
